<!--
@Time : 2020/11/30 7:03 上午
@Author : yekong
@File : chengbenkongzhi2.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div id="huodexindai3" :style="{width: '1200px', height: '250px'}"></div>
    <div id="huodexindai2" :style="{width: '1200px', height: '250px'}"></div>
  </div>
</template>

<script>
export default {
  name: "chengbenkongzhi2",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('huodexindai3'))
      // 绘制图表
      myChart.setOption({
        yAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false //小横线
          },
          axisLabel: {
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 26
            },
          },
          data: ['上海', '北京', '深圳', '大连']
        },
        xAxis: {
          show: true,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false //小横线
          },
          axisLabel: {
            show: false,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
        },
        grid: {
          top: '40',
          right: '50',
          left: '80',
          bottom: '0' //图表尺寸大小
        },
        series: [{
          /* data: [120, 200, 150, 80, 70, 110, 130], */
          type: 'bar',
          barWidth: '28px',
          label: {
            show: false,
            position: 'right',
            fontSize: 16,
            color: '#fff'
          },
          itemStyle: {
            normal: {
              label: {
                formatter: p => {
                  return p.value;
                },
                show: false,//是否显示
                position: 'right',//显示位置
                textStyle: { //文字样式
                  color: 'rgba(236, 239, 249, 1)',
                  fontSize: 30
                }
              },
              color: (params) => {
                let colors = ['rgba(62, 190, 225, 1)', 'rgba(62, 190, 225, 1)', 'rgba(62, 190, 225, 1)', 'rgba(237, 142, 92, 1)']
                return colors[params.dataIndex]
              }, //每个数据的颜色
            },
          },
          data: [
            {
              value: 1
            },
            {
              value: 6
            },
            {
              value: 12
            },
            {
              value: 20
            }
          ]
        }]
      });
    },
    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('huodexindai2'))
      // 绘制图表
      myChart.setOption({
        yAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false //小横线
          },
          axisLabel: {
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 26
            },
          },
          data: ['上海', '北京', '深圳', '大连']
        },
        xAxis: {
          show: true,
          minInterval: 6,
          interval: 6,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false //小横线
          },
          axisLabel: {
            show: true,
            scale: false,
            color: 'rgba(236, 239, 249, 1)',
            formatter: function (val) {
              return val + '小时';
            },
            textStyle: {
              fontSize: 30
            },
          },
        },
        grid: {
          top: '0',
          right: '50',
          left: '80',
          bottom: '40' //图表尺寸大小
        },
        series: [{
          /* data: [120, 200, 150, 80, 70, 110, 130], */
          type: 'bar',
          barWidth: '28px',
          label: {
            show: false,
            position: 'right',
            fontSize: 16,
            color: '#fff'
          },
          itemStyle: {
            normal: {
              label: {
                formatter: p => {
                  return p.value + '分';
                },
                show: false,//是否显示
                position: 'right',//显示位置
                textStyle: { //文字样式
                  color: 'rgba(236, 239, 249, 1)',
                  fontSize: 30
                }
              },
              color: (params) => {
                let colors = ['rgba(62, 190, 225, 1)', 'rgba(62, 190, 225, 1)', 'rgba(62, 190, 225, 1)', 'rgba(237, 142, 92, 1)']
                return colors[params.dataIndex]
              }, //每个数据的颜色
            },
          },
          data: [
            {
              value: 10
            },
            {
              value: 10
            },
            {
              value: 10
            },
            {
              value: 18
            }
          ]
        }]
      });
    }

  },
  mounted() {
    this.drawLine();
    this.drawLine2();
  },
}
</script>

<style lang="scss" scoped>

</style>
